import './App.css';
import Sysvis from './SystemDesignVis';


function App() {
  return (
    <div className="App">
      <Sysvis/>
    </div>
  );
}

export default App;
